import CustomCard from "components/CustomCard";
import TextInput from "components/files/TextInput"
import NullCheck from "components/NullCheck";

const Providers = ({ control, errors, data }) => {

  return (
    <NullCheck valueForCheck={data?.providers} >
      <CustomCard>
        <TextInput
          width="100%"
          errors={errors}
          name="providers"
          title="PROVIDERS"
          rows={5}
          readOnly
          control={control}
        />
      </CustomCard>
    </NullCheck>
  )
}
export default Providers